export const ROUTES = {
	HOME: '/',
	FEEDBACK: '/feature-request',
	EMBED_FEEDBACK: '/embed/feedback',
	ADMIN: {
		ROOT: '/admin',
		LOGIN: '/',
		PROJECT: (id: string) => `/admin/projects/${id}`,
	},
} as const;
